import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import './BaskanlaFotografim.scss';
import QuickMenu from '../../components/QuickMenu/QuickMenu';

const BaskanlaFotografim = () => {
  // Hard-coded photo array with at least 10 photos
  const [photos] = useState([
    {
      id: 1,
      src: '/Baskan/photo-1.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 1',
      title: 'Belediye Ziyareti'
    },
    {
      id: 2,
      src: '/Baskan/photo-2.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 2',
      title: 'Mahalle Ziyareti'
    },
    {
      id: 3,
      src: '/Baskan/photo-3.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 3',
      title: 'Etkinlik Katılımı'
    },
    {
      id: 4,
      src: '/Baskan/photo-4.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 4',
      title: 'Açılış Töreni'
    },
    {
      id: 5,
      src: '/Baskan/photo-5.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 5',
      title: 'Proje Tanıtımı'
    },
    {
      id: 6,
      src: '/Baskan/photo-6.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 6',
      title: 'Halk Günü'
    },
    {
      id: 7,
      src: '/Baskan/photo-7.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 7',
      title: 'Spor Etkinliği'
    },
    {
      id: 8,
      src: '/Baskan/photo-8.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 8',
      title: 'Kültür Etkinliği'
    },
    {
      id: 9,
      src: '/Baskan/photo-9.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 9',
      title: 'Okul Ziyareti'
    },
    {
      id: 10,
      src: '/Baskan/photo-10.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 10',
      title: 'Toplantı'
    },
    {
      id: 11,
      src: '/Baskan/photo-11.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 11',
      title: 'Park Açılışı'
    },
    {
      id: 12,
      src: '/Baskan/photo-12.jpg',
      alt: 'Başkan Mehmet Dönmez ile vatandaş fotoğrafı 12',
      title: 'Yardım Kampanyası'
    }
  ]);

  // State for lightbox
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  // Handler to open lightbox at specific photo index
  const openLightbox = (index) => {
    if (index >= 0 && index < photos.length) {
      setCurrentPhotoIndex(index);
      setIsLightboxOpen(true);
    }
  };

  // Handler to close lightbox
  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  // Handler for photo click
  const handlePhotoClick = (index) => {
    openLightbox(index);
  };

  // Handler for keyboard interaction on photo items
  const handlePhotoKeyPress = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openLightbox(index);
    }
  };

  // Handler for image loading errors
  const handleImageError = (event, photoSrc) => {
    console.warn(`Failed to load image: ${photoSrc}`);
    event.target.style.display = 'none';
  };

  // Convert photos to lightbox slides format
  const lightboxSlides = photos.map(photo => ({
    src: photo.src,
    alt: photo.alt,
    title: photo.title
  }));

  return (
    <div className="baskanla-fotografim">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-lg-10 col-md-7">
            <div className="page-content">
              <h1 className="page-title mb-3">Başkanla Fotoğrafım</h1>
              
              {photos.length === 0 ? (
                <div className="no-photos-message">
                  <p>Henüz fotoğraf eklenmemiş.</p>
                </div>
              ) : (
                <div className="photo-grid">
                  {photos.map((photo, index) => (
                    <div
                      key={photo.id}
                      className="photo-item"
                      onClick={() => handlePhotoClick(index)}
                      onKeyPress={(e) => handlePhotoKeyPress(e, index)}
                      tabIndex={0}
                      role="button"
                      aria-label={`${photo.alt}. Fotoğrafı büyütmek için tıklayın.`}
                    >
                      <img
                        src={photo.src}
                        alt={photo.alt}
                        loading="lazy"
                        onError={(e) => handleImageError(e, photo.src)}
                      />
                      {photo.title && (
                        <div className="photo-title">{photo.title}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox for photo viewing */}
      <Lightbox
        open={isLightboxOpen}
        close={closeLightbox}
        slides={lightboxSlides}
        index={currentPhotoIndex}
        plugins={[Zoom]}
        on={{
          view: ({ index }) => setCurrentPhotoIndex(index)
        }}
      />
    </div>
  );
};

export default BaskanlaFotografim;
